import React from "react";
import './24-7logo.css'




const Logo24_7 = () =>{

    return(<>
        <body>

    <div class="logo-container">
        <div class="icon-part">
            <span class="number-24">24</span>
        </div>
        <div class="text-part">
            <div class="top-line">
                <span class="hr">hr</span>
                <span class="service">SERVICE</span>
            </div>
            <div class="everyday">EVERYDAY</div>
        </div>
    </div>

</body>
    </>)

}
export default Logo24_7